import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";
import storage from "redux-persist/lib/storage";
import { getEnvVars } from "../environment";

export const STORAGE_KEY = "GlimpseWeb.20220204_1600";

export const SERVER_URL = getEnvVars().serverUrl;
export const WEBSOCKET_URL = getEnvVars().websocketUrl;

export const persistConfig = {
  key: STORAGE_KEY,
  storage: storage,
  stateReconciler: autoMergeLevel2,
  whitelist: [
    "auth"
  ],
  transforms: [],
};
